import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ChevronRight } from 'lucide-react';

/** Rimando alla guida di estrazione dati, da mettere in cima alle pagine di caricamento. */
export const LinkGuida = ({ testo = 'Come si estraggono i dati?' }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate('/promemoria')}
      data-testid="link-guida-promemoria"
      className="w-full flex items-center gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-left text-xs font-semibold text-primary transition-colors hover:bg-primary/10"
    >
      <BookOpen className="w-4 h-4 shrink-0" />
      <span className="flex-1">{testo}</span>
      <ChevronRight className="w-4 h-4 shrink-0" />
    </button>
  );
};

export default LinkGuida;
